// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".images[data-v-a182050a]{position:absolute;width:54px;height:27px;left:3px}[data-v-a182050a] .el-image__inner{opacity:0}.detail-centent[data-v-a182050a]{line-height:30px;font-size:14px}.textE93323[data-v-a182050a]{color:#e93323}.detail-title[data-v-a182050a]{font-size:16px}[data-v-a182050a] .el-icon-circle-close{color:#999}", ""]);
// Exports
module.exports = exports;
